import React from 'react'
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { PropTypes } from 'prop-types'
import styles from './ExpandableSection.icss'

class ExpandableSection extends React.Component {
	constructor(props) {
		super(props)

		this.renderSummary = this.renderSummary.bind(this)
	}

	renderSummary() {
		return typeof this.props.renderTitle === 'function' ?
			this.props.renderTitle() :
			(
				<div className="ExpandableSection_Summary">
					{typeof this.props.title === 'function' ? this.props.title() : this.props.title}
				</div>
			)
	}

	render() {
		return (
			<section>
				<ExpansionPanel defaultExpanded={this.props.defaultExpanded} classes={{ root: styles.expansionPanel }}>
					<ExpansionPanelSummary classes={{ root: styles.expansionSummary, expandIcon: styles.expandIcon }} expandIcon={<ExpandMoreIcon />}>
						{this.renderSummary()}
					</ExpansionPanelSummary>
					<ExpansionPanelDetails classes={{ root: styles.expansionDetails }}>
						{this.props.children}
					</ExpansionPanelDetails>
				</ExpansionPanel>
			</section>
		)
	}
}

ExpandableSection.propTypes = {
	children: PropTypes.node,
	defaultExpanded: PropTypes.bool,
	renderTitle: PropTypes.func,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
}

ExpandableSection.defaultProps = {
	children: undefined,
	defaultExpanded: false,
	renderTitle: undefined,
	title: undefined
}

export default ExpandableSection



// WEBPACK FOOTER //
// ./src/components/ExpandableSection.jsx